/**
 * Online orders (docs/SPEC.md, docs/BUILD-PHASES.md Phase 11).
 */
import { z } from 'zod';
import { idSchema } from './common.js';
export const placeOrderLineSchema = z.object({
    variantId: idSchema,
    qtyMilli: z.number().int().min(1).max(100_000_000),
    note: z.string().max(200).optional(),
});
/** COD needs no ref/proof; a transfer method may carry either or both — verification (README.md Phase 18) checks whatever was sent. */
export const orderPaymentSchema = z.object({
    method: z.enum(['COD', 'BANK_TRANSFER', 'WALLET']),
    ref: z.string().max(120).optional(),
    proofFileId: idSchema.optional(),
});
export const placeOrderSchema = z.object({
    businessCode: z.string().min(1).max(32),
    shopId: idSchema,
    fulfilment: z.enum(['PICKUP', 'DELIVERY']),
    contactPhone: z.string().min(7).max(20),
    contactName: z.string().max(120).optional(),
    deliveryAddress: z.string().max(500).optional(),
    deliveryNote: z.string().max(300).optional(),
    lines: z.array(placeOrderLineSchema).min(1),
    payment: orderPaymentSchema.optional(),
});
export const listOrdersQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(200).default(50),
    shopId: idSchema.optional(),
    status: z.string().optional(),
});
export const verifyOrderOtpSchema = z.object({ code: z.string().regex(/^\d{6}$/, 'Enter the 6-digit code') });
export const rejectOrderSchema = z.object({ reason: z.string().min(1).max(300) });
export const holdOrderSchema = z.object({ reason: z.string().max(300).optional() });
export const assignRiderSchema = z.object({
    riderName: z.string().min(1).max(120),
    riderPhone: z.string().max(20).optional(),
    riderEmployeeId: idSchema.optional(),
});
//# sourceMappingURL=orders.js.map